/**
 * Drop Form functionality
 * Handles contact form submission via AJAX
 */

(function() {
    'use strict';

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function getErrorElement(input) {
        if (!input) {
            return null;
        }

        const describedBy = input.getAttribute('aria-describedby');
        return describedBy ? input.form.querySelector('#' + describedBy) : null;
    }

    function initForm(form) {
        const emailInput = form.querySelector('input[type="email"]');
        const consentCheckbox = form.querySelector('input[type="checkbox"]');
        const submitButton = form.querySelector('button[type="submit"]');
        const successMessage = form.querySelector('.drop-form__message--success');
        const errorMessage = form.querySelector('.drop-form__message--error');
        const intercomTagInput = form.querySelector('input[name="intercom_tag"]');
        const intercomTagSigInput = form.querySelector('input[name="intercom_tag_sig"]');
        const downloadContainer = form.querySelector('.drop-form__download-container');

        if (!emailInput || !submitButton) {
            return;
        }

        const emailError = getErrorElement(emailInput);
        const consentError = getErrorElement(consentCheckbox);

        function resetErrors() {
            emailInput.classList.remove('drop-form__input--error');
            emailInput.setAttribute('aria-invalid', 'false');
            if (consentCheckbox) {
                consentCheckbox.classList.remove('drop-form__checkbox--error');
                consentCheckbox.setAttribute('aria-invalid', 'false');
            }
            if (emailError) {
                emailError.style.display = 'none';
            }
            if (consentError) {
                consentError.style.display = 'none';
            }
            if (successMessage) {
                successMessage.style.display = 'none';
            }
            if (errorMessage) {
                errorMessage.style.display = 'none';
            }
            // download stays put once earned - hiding it here would take it away
            // on the next submit attempt, including a client-side validation failure
        }

        function showFieldError(input, errorElement, message) {
            input.classList.add('drop-form__input--error');
            input.setAttribute('aria-invalid', 'true');
            if (errorElement) {
                errorElement.textContent = message;
                errorElement.style.display = 'block';
            }
        }

        form.addEventListener('submit', function(event) {
            event.preventDefault();

            resetErrors();
            let isValid = true;

            const emailValue = emailInput.value.trim();
            if (!emailValue) {
                showFieldError(emailInput, emailError, 'Toto pole je povinné.');
                isValid = false;
            } else if (!emailRegex.test(emailValue)) {
                showFieldError(emailInput, emailError, 'Zadejte prosím validní email');
                isValid = false;
            }

            if (!consentCheckbox || !consentCheckbox.checked) {
                if (consentCheckbox) {
                    consentCheckbox.classList.add('drop-form__checkbox--error');
                    consentCheckbox.setAttribute('aria-invalid', 'true');
                }
                if (consentError) {
                    consentError.textContent = 'Toto pole je povinné.';
                    consentError.style.display = 'block';
                }
                isValid = false;
            }

            if (!isValid) {
                return;
            }

            submitButton.disabled = true;
            const originalButtonText = submitButton.textContent;
            submitButton.textContent = window.engeto_drop_form_params?.translation_sending || 'Odesílám...';

            const nonceField = form.querySelector('input[name="drop_form_nonce"]');
            const nonce = nonceField ? nonceField.value : '';

            if (!nonce) {
                if (errorMessage) {
                    errorMessage.textContent = 'Bezpečnostní token chybí. Obnovte prosím stránku.';
                    errorMessage.style.display = 'block';
                }
                return;
            }

            const data = new FormData();
            data.append('action', 'drop_form');
            data.append('nonce', nonce);
            data.append('email', emailValue);
            data.append('consent', consentCheckbox && consentCheckbox.checked ? '1' : '0');
            const intercomTagValue = intercomTagInput ? intercomTagInput.value.trim() : '';
            if (intercomTagValue) {
                data.append('intercom_tag', intercomTagValue);
                data.append('intercom_tag_sig', intercomTagSigInput ? intercomTagSigInput.value : '');
            }

            let ajaxUrl = window.engeto_drop_form_params?.ajaxurl;
            if (!ajaxUrl) {
                ajaxUrl = window.engeto_params?.ajaxurl;
            }
            if (!ajaxUrl) {
                const protocol = window.location.protocol;
                const host = window.location.host;
                ajaxUrl = protocol + '//' + host + '/wp-admin/admin-ajax.php';
            }

            fetch(ajaxUrl, {
                method: 'POST',
                credentials: 'same-origin',
                body: data
            })
            .then(response => {
                return response.text().then(text => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    if (text === '0' || text.trim() === '0') {
                        throw new Error('AJAX handler error');
                    }
                    try {
                        return JSON.parse(text);
                    } catch (error) {
                        throw new Error('Invalid response');
                    }
                });
            })
            .then(response => {
                if (response.valid) {
                    if (downloadContainer) {
                        // clear the inline style instead of setting one, so the
                        // block's own layout classes stay in charge
                        downloadContainer.style.display = '';
                    }
                    if (successMessage) {
                        successMessage.style.display = 'block';
                        successMessage.focus();
                        successMessage.setAttribute('tabindex', '-1');
                        successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                    form.reset();
                    emailInput.setAttribute('aria-invalid', 'false');
                    if (consentCheckbox) {
                        consentCheckbox.setAttribute('aria-invalid', 'false');
                    }
                } else {
                    if (errorMessage) {
                        errorMessage.style.display = 'block';
                        if (response.message) {
                            errorMessage.textContent = response.message;
                        }
                        errorMessage.focus();
                        errorMessage.setAttribute('tabindex', '-1');
                    }
                    if (emailInput.classList.contains('drop-form__input--error')) {
                        emailInput.focus();
                    } else if (consentCheckbox && consentCheckbox.classList.contains('drop-form__checkbox--error')) {
                        consentCheckbox.focus();
                    }
                }
                submitButton.disabled = false;
                submitButton.textContent = originalButtonText;
            })
            .catch(() => {
                if (errorMessage) {
                    errorMessage.style.display = 'block';
                    errorMessage.focus();
                    errorMessage.setAttribute('tabindex', '-1');
                }
                submitButton.disabled = false;
                submitButton.textContent = originalButtonText;
            });
        });
    }

    function initDropForms() {
        const forms = document.querySelectorAll('.drop-form__form');
        forms.forEach(form => {
            if (form.dataset.dropFormApplied === '1') {
                return;
            }
            form.dataset.dropFormApplied = '1';
            initForm(form);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDropForms);
    } else {
        initDropForms();
    }
})();
